<template>
<div id="create-partner">
  <h2>Edit Partner</h2>

  <partner-form
    :partnerId="partnerId"
  ></partner-form>
</div>
</template>

<script>
import PartnerForm from '@/components/PartnerForm'

export default {
  data () {
    return {}
  },

  components: {
    'partner-form': PartnerForm
  },

  props: ['partnerId'],

  methods: {
    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/PartnerEdit.vue